import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TextField from "@mui/material/TextField";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DoneAllIcon from "@mui/icons-material/DoneAll";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import DeclareContext from "../../context/users/DeclareContext";
import MoveEndMap from "./MoveEndMap";

import AddrSearchModal from "../../components/AddrSearchModal";
import { use } from "echarts";
import UserCheckModal from "../../components/UserCheckModal";

// 텍스트 필드, 메뉴아이템 커스터마이징
const CustomTextField = styled(TextField)`
  && {
    & .MuiInputBase-root {
      border: 1px solid #ddd;
      color: #f4f5f5;
      background-color: #244ea2;
      text-align: left;
      height: 47.78px;
    }

    & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #f4f5f5;
    }

    & .MuiSelect-icon {
      color: #f4f5f5;
    }
  }
`;
const CustomMenuItem = styled(MenuItem)`
  && {
    background-color: #244ea2 !important;
    color: #f4f5f5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background-color: #1c236c !important;
    }

    & .MuiListItemIcon-root {
      min-width: 32px;
    }
  }
`;

const theme = createTheme({
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: "#244ea2",
        },
      },
    },
  },
});

const Declare = () => {
  const {
    name,
    setName,
    address,
    setAddress,
    phoneNm,
    setPhoneNm,
    dateTime,
    setDateTime,
    additionalNotes,
    setAdditionalNotes,
    handleSubmit,
    setXcoord,
    setYcoord,
    pwd,
    setPwd,
    pwdCheck,
    setPwdCheck,
    mwField,
    setMwField,
    mwType,
    setMwType,
    filedOptions,
    typeOptions,
    agree,
    setAgree,
    setPositionXY,
    addr,
    setAddr,
    positionXY,
    AddrToPos,
    searchType,
    setSearchType,
    getTargetList,
    setTargetDataList,
  } = useContext(DeclareContext);

  useEffect(() => {
    setAddr(addr);
    setAddress(address);
    setXcoord(positionXY && positionXY[0]);
    setYcoord(positionXY && positionXY[1]);
  }, [addr, positionXY, setAddress]);

  const max_length = 500;

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const navigate = useNavigate();

  // 경고 메세지
  const [warning, setWarning] = useState("");

  // 사용자확인 모달
  const [clickedPopup, setClickedPopup] = useState(false);
  const [fetchedName, setFetchedName] = useState("");
  const [fetchedPhone, setFetchedPhone] = useState("");

  const handleOpen = () => setClickedPopup(true);
  const handleClose = () => setClickedPopup(false);

  // 주소 검색 방법
  const addSearch = [
    { title: "도로명으로 검색", value: 0 },
    { title: "지번으로 검색", value: 1 },
    { title: "지도에서 검색", value: 2 },
  ];

  const searchChange = (e) => {
    setSearchType(e.target.value);
    setAddress("");
    setTargetDataList([]);
  };

  // 주소 검색과 타겟 리스트 가져오기
  const [searchResults, setSearchResults] = useState(false); // 검색 결과 표시 상태
  const handleSearch = async (searchInput) => {
    try {
      // 사용자가 입력한 주소를 좌표로 변환
      await AddrToPos(searchInput);
      // 변환된 좌표로 검색 결과를 가져오기
      const results = await getTargetList();
      // 검색 결과를 상태에 저장
      setSearchResults(results);
    } catch (error) {
      console.error("검색 중 오류 발생:", error);
    }
  };

  useEffect(() => {
    // 주소로 검색을 선택한 경우
    setMapClickEnabled(searchType !== 0);
  }, [searchType]);

  const [mapClickEnabled, setMapClickEnabled] = useState(false);
  // 지도 클릭 이벤트 핸들러
  const handleMapClick = () => {
    if (!mapClickEnabled) {
      return; // 지도 클릭이 비활성화된 경우 처리하지 않음
    }
  };

  const handleHome = () => {
    navigate("//");
  };

  const setPosition = (pos) => {
    setPositionXY(pos);
  };

  // 미동의시 팝업
  const handleRadioChange = (e) => {
    const value = e.target.value;
    if (value === "no") {
      alert("현재 개인정보 수집 미동의 시 답글을 확인하실 수 없습니다.");
      // 동의하지 않은 경우 이름과 휴대폰 번호를 null로 설정
      setName("");
      setPhoneNm("");
    } else if (value === "yes") {
      alert(
        "개인정보 수집 동의 완료. \n 이름과 휴대폰 번호를 필수로 입력해 주세요."
      );
    }
    setAgree(value);
  };

  return (
    <ThemeProvider theme={theme}>
      <main className='declare-container'>
        <div className='declare-box'>
          <div className='declare-title'>
            <div className='title'>
              <h1>악취 민원 신고</h1>
            </div>
            <Button className='list-btn' variant='contained' onClick={handleOpen}>
              내 민원 확인
            </Button>
            <UserCheckModal open={clickedPopup} handleClose={handleClose} fetchedName={fetchedName} fetchedPhone={fetchedPhone} />
          </div>
          <div className='map-container' style={{ pointerEvents: mapClickEnabled ? 'auto' : 'none' }}>
            <MoveEndMap func={setPosition} onClick={handleMapClick} enableInteractions={mapClickEnabled} positionXY={positionXY} />
          </div>
          <Box fullWidth sx={{ gap: '13px', width: '100%', display: 'grid' }}>
            {warning && <p style={{ color: 'red' }}>{warning}</p>}
            <strong>지도에서 검색을 선택한 경우에만 지도 이동이 가능합니다.</strong>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <FormControl fullWidth style={{ marginBottom: 15, width: '90%' }}>
                <FormLabel>주소 검색 방식 </FormLabel>
                <CustomTextField select labelid='search-type-label' value={searchType} onChange={searchChange}>
                  {addSearch.map(option => (
                    <CustomMenuItem key={option.value} value={option.value}>
                      {option.title}
                    </CustomMenuItem>
                  ))}
                </CustomTextField>
              </FormControl>
              <div style={{ minWidth: '120px', textAlign: 'center' }}>
                {searchType === 0 || searchType === 1 ? (
                  <AddrSearchModal onSearch={handleSearch} searchType={searchType} />
                ) : (
                  // 여기에 빈 div를 넣어 버튼의 자리 유지
                  <div style={{ visibility: 'hidden' }}>
                    <AddrSearchModal />
                  </div>
                )}
              </div>
            </div>
            <FormControl>
              <FormLabel>주소* </FormLabel>
              <TextField placeholder='원하는 위치에 +를 맞춰주세요.' type='text' fullWidth value={address} readOnly />
            </FormControl>

            <FormControl>
              <FormLabel htmlFor='username'>작성자 이름 </FormLabel>
              <TextField
                value={name ? name : ''}
                type='text'
                id='username'
                name='username'
                autoComplete='off' //자동완성 해제
                placeholder='이름을 입력해 주세요.'
                onChange={handleNameChange}
                disabled={agree === 'no'}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor='phone'>전화번호 (휴대폰 번호) </FormLabel>
              <TextField
                placeholder='숫자만 입력 바랍니다.'
                type='tel'
                id='phone'
                name='phone'
                textfieldmode='numeric'
                autoComplete='off'
                value={phoneNm ? phoneNm.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1') : ''}
                onChange={e => setPhoneNm(e.target.value)}
                disabled={agree === 'no'}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor='date'>악취 발생 일시 (신고일시)* </FormLabel>
              <TextField
                type='datetime-local'
                id='date'
                name='date'
                required //필수입력
                value={dateTime}
                onChange={e => setDateTime(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>악취 종류* </FormLabel>
              <CustomTextField select value={mwType} onChange={e => setMwType(e.target.value)} style={{ marginBottom: 15 }} fullWidth>
                {typeOptions.map(option => (
                  <CustomMenuItem key={option.value} value={option.value}>
                    {option.name}
                  </CustomMenuItem>
                ))}
              </CustomTextField>
            </FormControl>
            <FormControl>
              <FormLabel>악취 강도* </FormLabel>
              <CustomTextField select value={mwField} onChange={e => setMwField(e.target.value)} fullWidth>
                {filedOptions.map(option => (
                  <CustomMenuItem key={option.value} value={option.value}>
                    {option.name}
                  </CustomMenuItem>
                ))}
              </CustomTextField>

              <div className='oderexplain'>
                무취 - 평상시 후각으로 아무것도 감지하지 못하는 정도
                <br /> 약간느낌 - 무슨 냄새인지 알 수 없으나 약간의 냄새를 느낄 수 있는 정도
                <br /> 보통냄새 - 무슨 냄새인지 알 수 있는 정도
                <br /> 강한냄새 - 쉽게 감지할 수 있는 정도의 강한 냄새, 병원의 크레졸 냄새 수준
                <br /> 극심한냄새 - 아주 강한 냄새, 여름철 재래식 화장실냄새 수준
                <br /> 참기어려운냄새 - 견디기 어려운 강렬한 냄새로써 호흡이 정지될 것 같은 수준
              </div>
            </FormControl>
            <FormControl>
              <FormLabel>추가 내용* </FormLabel>
              <TextField
                value={additionalNotes}
                htmlFor='description'
                placeholder='500자 이내로 작성 바랍니다.'
                maxLength={500}
                multiline
                minRows={5}
                maxRows={7}
                onChange={e => setAdditionalNotes(e.target.value)}
                color={additionalNotes && additionalNotes.length > 500 ? 'error' : ''}
              />
              <p>
                <span
                  style={{
                    color: additionalNotes && additionalNotes.length > 500 ? 'red' : 'inherit',
                  }}
                >
                  {(additionalNotes ? additionalNotes.length : 0).toLocaleString()}/{max_length.toLocaleString()}자
                </span>
              </p>
            </FormControl>

            <FormControl
              sx={{
                justifyContent: 'flex-start',
                paddingBottom: 2,
                width: '100%',
              }}
            >
              <FormLabel>
                개인정보 수집 동의 * &nbsp;
                <DoneAllIcon sx={{ color: 'red' }} />
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby='demo-row-radio-buttons-group-label'
                name='row-radio-buttons-group'
                className='radiogroup'
                defaultValue='yes'
                onChange={handleRadioChange}
              >
                <FormControlLabel value='yes' control={<Radio />} label='예' />
                <FormControlLabel value='no' control={<Radio />} label='아니오' />
              </RadioGroup>
              <Accordion className='accordion' sx={{ borderRadius: 1 }}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls='panel1-content'
                  id='panel1-header'
                  sx={{ backgroundColor: '#e6f2fc' }}
                >
                  <Typography>내용보기</Typography>
                </AccordionSummary>
                <AccordionDetails className='oderexplain_con'>
                  <div>
                    <strong className='addexplain'>** 주민등록번호, 이메일 등 개인정보는 입력하지 않습니다.</strong>
                    <br /> <br />
                    <strong>1. 개인정보의 수집 및 이용 목적(개인정보보호법 제15조)</strong>
                    <p>
                      수집된 개인정보는 정해진 목적 이외의 용도로는 이용되지 않으며 수집 목적이 변경될 경우 사전에 알리고 동의를 받을 예정입니다.{' '}
                      <br />※ 관계법령 등 : 민원사무 처리에 관한 법률 및 동법 시행령, 행정안전부의 설치와 운영에 관한 법률, 전자정부법 및 동법 시행령
                      등 <br />
                      가. 민원사무 접수·처리·사후관리 서비스 제공민원신청서에 포함된 개인정보는 민원의 접수·처리 등 소관 업무 수행을 위해
                      행정·공공기관에서 이용합니다. <br />
                      나. 타 행정·공공기관 시스템 이용민원사무의 전자적 처리를 위해 내부적으로 타 시스템 연계 및 이용 시 개인정보를 이용합니다. <br />
                      다. 악취 민원서비스 향상 및 정책평가를 위하여 접수된 민원은 관계 법령에 따라 분석·평가 및 처리결과의 사후관리를 시행합니다.
                    </p>
                  </div>
                  <br />
                  <div>
                    <strong>2. 수집하는 개인정보의 항목(개인정보보호법 제15조, 제16조)</strong>
                    <p>가. 필수항목: 휴대전화, 성명</p>
                  </div>
                  <br />
                  <div>
                    <strong>3. 개인정보의 보유 및 이용기간(공공기록물 관리에 관한 법률 시행령 제26조)</strong>
                    <p>
                      인천시는 원칙적으로 개인정보 보존기간이 경과하거나, 처리목적이 달성된 경우에는 지체 없이 개인정보를 파기합니다. 다만, 다른
                      법령에 따라 보존하여야 하는 경우에는 그러하지 않을 수 있습니다.
                    </p>
                    <br />
                    <h2 style={{ color: '#3897e1', margin: 2 }}>1) 신고, 제안: 3년</h2>
                    <h2 style={{ color: '#3897e1', margin: 2 }}>2) 회원정보: 민원 삭제시 즉시 파기</h2>
                    <br />
                  </div>
                </AccordionDetails>
              </Accordion>
            </FormControl>
            <FormControl>
              <div
                className='pwCheck'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                <div>
                  <FormLabel htmlFor='hiddenField'>비밀번호* </FormLabel>
                  <TextField type='password' value={pwd} id='hiddenField' name='hiddenField' onChange={e => setPwd(e.target.value)} />
                </div>
                <div className='pwdcheck'>
                  <div>
                    <FormLabel htmlFor='hiddenField'>비밀번호 확인* </FormLabel>
                    <TextField
                      type='password'
                      value={pwdCheck}
                      id='hiddenField'
                      name='hiddenField'
                      onChange={e => setPwdCheck(e.target.value)}
                      color={pwd === pwdCheck ? 'success' : 'error'}
                    />
                  </div>
                  <div>
                    {pwd && pwdCheck ? (
                      pwd === pwdCheck ? (
                        <small style={{ color: 'green' }}>*비밀번호가 동일합니다.</small>
                      ) : (
                        <small style={{ color: 'red' }}>*비밀번호가 다릅니다.</small>
                      )
                    ) : (
                      <small style={{ color: 'orange' }}>*비밀번호를 입력해주세요.</small>
                    )}
                  </div>
                </div>
              </div>

              <div className='button-container' style={{ textAlign: 'center' }}>
                <Button variant='outlined' color='error' onClick={handleHome}>
                  취소
                </Button>
                <Button
                  variant='contained'
                  color='success'
                  onClick={() => {
                    if (pwd !== pwdCheck) {
                      alert('비밀번호가 다릅니다. 다시 입력해주세요.');
                    } else {
                      handleSubmit();
                    }
                  }}
                  sx={{ m: 2 }}
                >
                  등록
                </Button>
              </div>
            </FormControl>
          </Box>
        </div>
      </main>
    </ThemeProvider>
  );
};

export default Declare;
